import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: left;
  //position: relative;
  width: 100%;

  & > * {
    font-size: 16px;
    font-family: Montserrat;
    font-weight: 500;
  }
`;

const TextDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border:${(props) => props.Border};
  border-radius:15px;
  margin-top: ${(props) => props.marginTop}
  & > * {
    font-size: 16px;
    font-family: Montserrat;
    font-weight: 500;
  }

  & > span {
    margin-left: -40px;
    color: #636363;
  }
`;



const InputTitle = styled.label`
  padding: 8px;
  width: 100%;
//   margin-left: ${(props) => props.marginTopVal ? '8px' : ''}
`;

const ErrorMessage = styled.div`
  padding: 2px 10px;

  color: #d74748;
  font-family: Montserrat;
  font-size: 14px; 
  font-weight: 500;
  line-height: normal;
`;

const TextArea = ({
    marginTop = '10px',
    Border = '1px solid rgb(162, 162, 162)',
    setChange,
    label,
    require,
    type,
    name,
    placeholder,
    value,
    onChange,
    customStyle,
    characterLimit,
    maxLength,
    limit,
    readOnly,
    error = '',
    paddingText='8px 12px',
    showBorder=false,
    marginTopVal=false
}) => {
    const [remainingCharacters, setRemainingCharacters] =
        useState(characterLimit);


    const [message, setMessage] = useState('');

    // Function to handle textarea input
    const handleInput = (event) => {
        if (setChange) {
            const textarea = event.target;
    
            // Reset height to shrink when needed
            textarea.style.height = 'auto';
    
            // Set height based on content (min 55px)
            textarea.style.height = Math.max(textarea.scrollHeight, 55) + 'px';
    
            setMessage(textarea.value);
            onChange(event);
        }
    };
    




    useEffect(() => {
        if (value) {
            setRemainingCharacters(characterLimit - value.length);
        }
    }, [value, characterLimit]);

    return (
        <Wrapper>
            {label && (
                <>
                    <InputTitle marginTopVal={marginTopVal}>
                        {label}
                        {require && <span style={{ color: '#FC6758' }}> *</span>}
                    </InputTitle>
                    <br />
                </>
            )}
            <TextDiv marginTop={marginTop} border={Border}>
                <textarea

                    data-testid="message-box"
                    type={type || 'text'}
                    name={name || ''}
                    id="message-box"
                    placeholder={placeholder}
                    onChange={handleInput}
                    style={{
                        resize: 'none',
                        width: '91%',
                        minHeight: '55px',
                        padding: paddingText,
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                        // border: 'none',
                        borderRadius: '15px',
                        alignContent: 'center',
                        outline: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 500,
                        border:showBorder ? '1px solid rgb(162, 162, 162)' : 'none',
                        
                        marginTop:marginTopVal ? '10px' : '',
                    }}


                    value={value}
                    maxLength={maxLength}
                    limit={limit}
                    error={error}
                    readOnly={readOnly}
                />

                {value && characterLimit ? (
                    <span>{remainingCharacters}</span>
                ) : (
                    <span>{limit}</span>
                )}
            </TextDiv>
        </Wrapper>
    );
};

export default TextArea;
